/**
 * Maps human-readable keys to Framer XLIFF translation unit IDs
 * or manual key names for the locations page.
 *
 * Framer keys are 22-char alphanumeric IDs; manual keys are camelCase
 * strings added directly to messages/{locale}.json.
 */
export const locationsKeys = {
  // Hero
  heroLabel: "heroLabel", // "Locations"
  heroHeading: "heroHeading", // "Find a clinic near you"
  heroSubtitle: "heroSubtitle", // "We partner with leading..."

  // Tab switcher — Switzerland country (used on /ch/*)
  tabSwitzerland: "tabSwitzerland", // "🇨🇭 Switzerland" (flag added in JSX)
  tabRestOfEurope: "tabRestOfEurope", // "🇪🇺 Rest of Europe" (flag added in JSX)
  // Tab switcher — Germany country (used on /de/*). "Übrige EU" is the
  // natural German pair for "Deutschland" since DE is itself part of the EU,
  // so "Übriges Europa" (used on /ch/de) reads slightly off here.
  tabGermany: "tabGermany", // "🇩🇪 Germany" (flag added in JSX)
  tabRestOfEu: "tabRestOfEu", // "🇪🇺 Rest of the EU" (flag added in JSX)

  // Switzerland section
  switzerlandHeading: "switzerlandHeading",
  locationCount: "locationCount", // "9 locations"

  // Section labels (uppercase trackers above clinic grids)
  mriSectionLabel: "mriSectionLabel",
  bloodSectionLabel: "bloodSectionLabel",
  fullBodyCheckupNote: "fullBodyCheckupNote", // "Blood tests are only available as part of the full-body check-up."

  // Clinic cards
  fullBodyCheckupBadge: "fullBodyCheckupBadge",
  bloodTestBadge: "bloodTestBadge",
  bookCheckup: "bookCheckup",

  // Map legend
  legendMri: "legendMri", // "MRI check-up"
  legendBlood: "legendBlood", // "Blood test"
  legendComingSoon: "legendComingSoon", // "Waitlist available" (Warteliste verfügbar) — DE only

  // Europe section
  europeHeading: "europeHeading",
  europeSubtitle: "europeSubtitle", // "We're expanding. Join the waitlist..."

  // Live-market card — a country we already serve, shown instead of a waitlist
  liveMarketPill: "liveMarketPill", // "Now available"
  liveMarketCta: "liveMarketCta", // "Visit this country's site"

  // EU waitlist cards
  comingSoon: "comingSoon",
  notifyMe: "notifyMe", // "Notify me"
  wellNotifyYou: "wellNotifyYou", // "We'll notify you"
  emailPlaceholder: "emailPlaceholder",
  joinWaitlistBtn: "joinWaitlistBtn", // "Join waitlist"

  // Bottom CTA
  ctaHeading: "ctaHeading",
  ctaBookCheckup: "ctaBookCheckup", // "Book check-up"
  ctaTalkToTeam: "ctaTalkToTeam", // "Talk to our team"
} as const
